<template>
	<div id="master-activity-list">
		<div class="sticky-table-header">
            <vx-card style="overflow-x: auto;">
                <vs-row>
                    <vs-col class="search-bar" vs-type="flex" vs-justify="right" vs-align="center">
                        <vs-spacer></vs-spacer>
						
						<!--
						<vs-tooltip text="Tambah">
							<vs-button radius size="large" type="border" color="#5d9fc6" icon="add" class="ml-3" @click="create()"></vs-button>
						</vs-tooltip>
						-->
						<vs-tooltip text="Edit" v-if="btnEdit === true">
							<vs-button radius size="large" type="border" color="warning" icon="edit" class="ml-3" @click="edit()"></vs-button>
						</vs-tooltip>
						<!--
						<vs-tooltip text="Hapus" v-if="btnDel === true">
							<vs-button radius size="large" type="border" color="danger" icon="delete" class="ml-3"></vs-button>
						</vs-tooltip>
						-->
					</vs-col>
				</vs-row>
			</vx-card>
		</div>

		<vx-card title="Daftar Bagian Lab" class="sticky-table-content mt-sticky">
			<vs-table stripe class="mb-base" :data="listData" style="text-align:left;" @selected="handleSelected">
				<template slot="thead">
					<vs-th>Kode</vs-th>
					<vs-th>Nama</vs-th>
					<vs-th>Panjang Barcode</vs-th>
					<vs-th>Prefix Barcode</vs-th>
					<vs-th>Specimen Collection</vs-th>
				</template>
				<template slot-scope="{data}">
					<vs-tr :state="tr.id==idSelected?'primary':null" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td>
							{{data[indextr].name}}
						</vs-td>
						<vs-td>
							{{data[indextr].description}}
						</vs-td>
						<vs-td>
							{{data[indextr].barcodeLength}}
						</vs-td>
						<vs-td>
							{{data[indextr].barcodePrefix}}
						</vs-td>
						<vs-td>
							{{data[indextr].specimenCollection}}
						</vs-td>																		
					</vs-tr>
				</template>
			</vs-table>
		</vx-card>
	</div>

</template>

<script>
import ref from "@/api/ref.js";
import formsearch from "@/api/form-search.js";
import lab from "@/api/lab.js";
import tool from "@/tool/form_tool.js";
import { VueContext } from "vue-context";


export default {
	components: {
		VueContext
	},
	data() {
		return {
			idSelected: null,
			listData: {maxPage:0, data: []},
			loading: true,
			perPage: 50,
			page: 1,
			totalItem: 1,

			btnEdit: false,
      		btnDel: false,

			model: {},
			schema: {
				fields: []
			},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
			}
		};
	},
	methods: {
		listen(newVal, schema) {
			if (schema == "provinceId") {
				this.getCityByProvince(false);
				return;
			}
		},
		async find(pg) {
			this.model["perPage"] = this.perPage;
			this.model["page"] = pg;
			this.listData= {maxPage:0, data: []};
			const frm = await lab.listBagianLab(this.model);
			if (frm.data.status != false) {
				this.listData = frm.data.data;
				this.totalItem = frm.data.maxPage;
			}
		},
		async firstLoad() {
			//const frms = await formsearch.getFormUser();
			//this.schema.fields = frms.data.data[0].fields;
			//this.model = frms.data.data[0].model;
			//await this.getRole();
			this.find(1);
		},
		async getRole() {
			const prov = await ref.getRole();
			tool.copyValuesToDropDown(
				this.schema.fields,
				"roleId",
				prov.data.data
			);
		},
		handleSelected(tr) {
			this.idSelected = tr.id;
			this.btnEdit = true;
			this.btnDel = true;
		},
		create() {
			this.$router.push('/lab/bagianlab/create');
		},
		edit() {
			this.$router.push({name: 'pemeriksaan-bagianlab-edit', params: {id: this.idSelected}});
		}
	},
	computed: {},
	created() {
		this.firstLoad();
	},
	watch: {
		page: function(newValue, oldValue) {
			// here you can do whatever you want
			this.find(newValue);
		}
	}
};
</script>
